import {computed, ref} from 'vue';

import type {TId} from '@/assets/core/assets/api/types';

import type {Feature} from '@turf/turf';

export const useFeatureCacheHook = () => {
  const cache = ref<Record<TId, Feature[]>>({});

  const getCache = computed(() => cache.value);

  return {
    cache,

    getCache,
  };
};

export const featureCache = useFeatureCacheHook();
